import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./AdminAuth.css";

function AdminSignup() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    phone: "",
    address: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = (e) => {
    e.preventDefault();

    if (form.email !== form.confirmEmail) {
      alert("Email does not match");
      return;
    }

    if (form.password !== form.confirmPassword) {
      alert("Password does not match");
      return;
    }

    // Save admin data in localStorage
    localStorage.setItem("admin", JSON.stringify(form));

    alert("Admin Signup Successful!");
    navigate("/admin");
  };

  return (
    <div className="admin-container">
      <div className="admin-card">
        <h2> Signup</h2>

        <form onSubmit={handleSignup}>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="confirmEmail"
            placeholder="Confirm Email"
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="address"
            placeholder="Address"
            onChange={handleChange}
            required
          />

          <button type="submit">Signup</button>
        </form>

        <p>
          Already have an account? <Link to="/admin">Login</Link>
        </p>
      </div>
    </div>
  );
}

export default AdminSignup;
